import { TriangleAlertIcon } from '@air/design-icons';

import { DELETE_ASSETS_WARNING } from '~/constants/testIDs';

export const DeleteAssetsWarning = () => {
  return (
    <div className="flex items-center justify-start" data-testid={DELETE_ASSETS_WARNING}>
      <TriangleAlertIcon size="lg" className="ads:text-icon-error text-flamingo-300" />
      <div className="ml-2 ads:text-error text-14 text-flamingo-700">
        Deleted assets <span className="font-semibold text-14 text-inherit">cannot be recovered</span>
      </div>
    </div>
  );
};
